module.exports = __webpack_public_path__ + "static/media/konstantin_zamkov.29b4590e.jpg";